import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  paymentHistory: [],
  loading: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
